import React from 'react'

// material ui
import Tooltip from '@mui/material/Tooltip'
import Icon from '@mui/icons-material/HelpOutlineOutlined'
import { styled } from '@mui/material/styles'
import { compose, spacing, palette } from '@mui/system'

const StyledIcon = styled(Icon)(compose(spacing, palette))

const HelpIcon = ({ toolTip, onClick }) => {
  return (
    <Tooltip title={toolTip}>
      <StyledIcon
        mx={0.5}
        fontSize='small'
        color='text.secondary'
        onClick={onClick}
      />
    </Tooltip>
  )
}

export default HelpIcon
